export default "__VITE_ASSET__cfe329d0__"